import {MetaData} from "@qid/core";
import {FeatureGroup} from "../../../feature-group";


export class Feature extends MetaData {

  _id: string;
  keyName: string;
  name: string;
  description: string;
  priceModel: 'Quota-Based' | 'Pay-Per-Use';
  defaultQuota: number;
  defaultPrice: number;
  featureGroup: FeatureGroup;
  constructor() {
    super();
  }

}


